<div  class="footer-sp container">
  <hr>
  <div  class="row" style="position: relative;">
    <div  class="d-flex" style="justify-content: center;">
      <div class="d-flex mb-0 mt-0 mx-0">
        <p  class="mb-0 mt-0 mx-0 mr-1" style="color: #4F4F4F !important;font-size: 15px !important;">🔒Pagamento </p>
        <p style="color: #4F4F4F !important;font-size: 15px !important;font-weight: bold !important;"
          class="mb-0 mt-0 mx-0 mr-1">criptografado e processado</p>
        <p  class="mb-0 mt-0 mx-0 mr-1" style="color: #4F4F4F !important;font-size: 15px !important;">por</p>
        <a target="_blank" href="https://krabo.com.br">
          <img src="assets/img/logo_krabo.png" width="60px" alt="" class="img-fluid">
        </a>
      </div>
    </div>
  </div>
</div>